<!--家长预约模块-->
<template>
  <div class="parents-reservation">
    <div class="content">
      <div class="select-garden">
        <div class="name">Kids 'R' Kids报名表</div>
      </div>
      <div class="from-box">
        <div class="rows">
          <p class="label check">选择园所 Choose School</p>
          <el-select v-model="formData.garden" placeholder="请选择" @change="getGardenMessage">
            <!--过滤上海奇思幼儿园-->
            <!--过滤北京旗舰幼儿园-->
            <el-option
              v-for="item in gardenData"
              :key="item.id"
              :label="item.gardenName"
              :value="item.id"
              v-show="item.id!=15 && item.id!=2"
            ></el-option>
          </el-select>
        </div>
        <div class="rows">
          <p class="label check">宝宝姓名 Child Name</p>
          <input type="text" class="editInp" v-model="formData.childName" />
        </div>
        <div class="rows">
          <p class="label check">性别 Gender</p>
          <ul class="radio-box">
            <li
              v-for="(item,index) in sex"
              :key="index"
              class="radio-item"
              :class="{'active':item.active}"
              @click.stop="selectSex(item)"
            >
              <i></i>
              <span>{{item.name}}</span>
            </li>
          </ul>
        </div>
        <div class="rows date">
          <p class="label check date">生日 Date of Birth</p>
          <el-date-picker
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            v-model="formData.birthday"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
        <div class="rows">
          <p class="label check">您的姓名 Your Name</p>
          <input type="text" class="editInp" v-model="formData.name" />
        </div>
        <div class="rows">
          <p class="label check">家庭住址 Your Home Address</p>
          <input type="text" class="editInp" v-model="formData.address" />
        </div>
        <div class="rows">
          <p class="label check">手机号码 Phone Number</p>
          <input type="text" class="editInp" v-model="formData.phone" @blur="blurPhone($event)" />
          <div v-if="showError" class="phone-error">请输入正确的手机号码</div>
        </div>
        <div class="rows channel-row">
          <p class="label">您是如何知道我们的？ How did you get to know us?</p>
          <ul class="radio-box channel">
            <li
              v-for="(item,index) in channel"
              :key="index"
              class="radio-item"
              :class="{'active':item.active}"
              @click.stop="selectChannel(item)"
            >
              <i></i>
              <span>{{item.name}}</span>
            </li>
          </ul>
        </div>
        <div class="rows note-row">
          <p class="label">您的关注和特别说明 Note</p>
          <textarea rows="4" class="textarea" v-model="formData.note"></textarea>
        </div>
        <p class="submit-btn" @click.stop="submitForm();">报名预约Submit</p>
      </div>
      <!-- 园所信息 -->
      <div class="garden-information">
        <div class="left">
          <div class="info">
            <i class="icon icon1"></i>
            <span v-if="phone">电话 &nbsp;&nbsp;{{phone}}</span>
            <span v-else>电话 &nbsp;&nbsp;--</span>
          </div>
          <div class="info">
            <i class="icon icon2"></i>
            <span v-if="addr">地址 &nbsp;&nbsp;{{addr}}</span>
            <span v-else>地址 &nbsp;&nbsp;--</span>
          </div>
          <div class="info" v-show="!this.$store.state.isMobile">
            <i class="icon icon3"></i>
            <span>如果您想使用手机端报名，请扫描右方二维码</span>
          </div>
        </div>
        <div class="right">
          <!--:style="{backgroundImage:'url('+ item_child +')'}"-->
          <img :src="code" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-datetime/dist/vue-datetime.css";
import { Datetime } from "vue-datetime";
import { Select, DatePicker } from "element-ui";
export default {
  data() {
    return {
      showSelect: false,
      gardenData: [],
      sex: [
        {
          name: "男",
          value: "1",
          active: true
        },
        {
          name: "女",
          value: "2",
          active: false
        }
      ],
      channel: [
        {
          name: "朋友推荐 Friends",
          value: "1",
          active: false
        },
        {
          name: "网络搜索 Internet",
          value: "2",
          active: false
        },
        {
          name: "户外广告 Outdoor Ad.",
          value: "3",
          active: false
        },
        {
          name: "报刊杂志 Magazine",
          value: "4",
          active: false
        },
        {
          name: "线上媒体 Online Media",
          value: "5",
          active: false
        },
        {
          name: "其他 Others",
          value: "6",
          active: false
        }
      ],
      formData: {
        garden: "",
        gardenMs: "",
        childName: "",
        sex: "1",
        birthday: "",
        name: "",
        address: "",
        phone: "",
        channel: "",
        note: ""
      },
      phone: "",
      addr: "",
      code: "https://krk-website.oss-cn-beijing.aliyuncs.com/img/news/code.png",
      id: "",
      showError: false,
      channelSource: null
    };
  },
  mounted() {
    this.globalClick(this.selectRemove);
    this.getChannelList();
    this.$get("/garden/getAllGardenList", {})
      .then(res => {
        this.gardenData = res.data;
      })
      .catch(() => {});
  },
  components: {
    datetime: Datetime,
    Select,
    DatePicker
  },
  methods: {
    blurPhone(e) {
      let phoneReg = /(^1[3|4|5|7|8]\d{9}$)|(^09\d{8}$)/,
        tar = e.target;
      if (!phoneReg.test(this.formData.phone)) {
        this.showError = true;
        return false;
      } else {
        this.showError = false;
        return true;
      }
    },
    getGardenMessage(item) {
      this.$post("/garden/getGardenByIDForPublic", { id: item })
        .then(res => {
          if (res.code === "00") {
            this.phone = res.data.linkPhone;
            this.addr = res.data.city + res.data.district + res.data.address;
            this.showSelect = false;
            this.formData.gardenMs = res.data.gardenName;
            this.formData.garden = res.data.id;
          }
        })
        .catch(() => {});
    },
    selectRemove() {
      this.showSelect = false;
    },
    selectGarden() {
      this.showSelect = !this.showSelect;
    },
    activeGarden(item) {
      this.gardenData.forEach(k => {
        k.active = false;
      });
      item.active = true;
      this.formData.gardenMs = item.name;
      this.formData.garden = item.value;
      this.showSelect = false;
    },
    selectSex(item) {
      this.sex.forEach(k => {
        k.active = false;
      });
      item.active = true;
      this.formData.sex = item.value;
    },
    selectChannel(item) {
      this.channel.forEach(k => {
        k.active = false;
      });
      item.active = true;
      this.formData.channel = item.name;
    },
    getChannelList() {
      this.$post("/recruit/channel/search", {})
        .then(res => {
          if (res.code === "00") {
            if (res.data && res.data.length > 0) {
              res.data.forEach((ele, i) => {
                if (ele.code == "WEBSITE") {
                  this.channelSource = ele.id;
                }
              });
            }
          }
        })
        .catch(() => {});
    },
    clear() {
      this.formData = {
        garden: "",
        gardenMs: "",
        childName: "",
        sex: "1",
        birthday: "",
        name: "",
        address: "",
        phone: "",
        channel: "",
        note: ""
      };
    },
    submitForm() {
      let temp = this.formData;
      if (
        !temp.childName ||
        !temp.sex ||
        !temp.birthday ||
        !temp.name ||
        !temp.address ||
        !temp.phone ||
        !temp.garden
      ) {
        alert("请填写完整");
        return;
      }
      let channel = this.formData.channel.split(" ");
      let birthday = this.formData.birthday.slice(0, 10);
      let params = {
        babyName: this.formData.childName,
        sex: parseInt(this.formData.sex),
        babyBirth: birthday,
        enrolment: this.formData.name,
        phone: this.formData.phone,
        remark: this.formData.note,
        homeAddress: this.formData.address,
        source: channel[0],
        channel: this.channelSource,
        gardenId: parseInt(this.formData.garden)
      };
      this.$post("/recruit/saveRecruitForPublic", params)
        .then(res => {
          if (res.code == "00") {
            alert("报名成功");
            this.clear();
          }
        })
        .catch(() => {
          console.log(err);
        });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.parents-reservation {
  width: 100%;
  .content {
    overflow: hidden;
    .select-garden {
      position: relative;
      text-align: center;
      margin-top: 100px;
      margin-bottom: 100px;
      .name {
        display: inline-block;
        position: relative;
        padding-right: 20px;
        font-size: 24px;
        color: rgba(51, 51, 51, 1);
        height: 30px;
        // cursor: pointer;
        .u-arrow {
          display: inline-block;
          width: 7px;
          height: 7px;
          border-top: 1px solid #333;
          border-right: 1px solid rgb(37, 8, 8);
          transform: rotate(45deg);
        }
      }
      .select-box {
        position: absolute;
        top: 30px;
        left: 50%;
        width: 300px;
        margin-left: -100px;
        border: 1px solid $color-primary;
        border-radius: 5px;
        background: #fff;
        box-sizing: border-box;
        z-index: 1000000;
        li.item {
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          color: #333;
          text-align: left;
          padding: 0 10px;
          box-sizing: border-box;
          font-family: PingFangSC-Medium;
        }
        li.item:hover {
          background: $color-primary;
          color: #fff;
        }
      }
      .select-box::before {
        content: "";
        position: absolute;
        top: -5px;
        left: 50%;
        width: 7px;
        height: 7px;
        border-top: 1px solid $color-primary;
        border-right: 1px solid $color-primary;
        background: #fff;
        transform: rotate(-45deg);
      }
    }
    .date-icon {
      position: absolute;
      top: 40px;
      left: 10px;
      display: block;
      width: 20px;
      height: 20px;
      background: url("../../assets/image/signup_icon_date.png") no-repeat;
      background-size: 100% 100%;
    }
    .from-box {
      width: 680px;
      margin: 0 auto;
      font-family: PingFangSC-Regular;
      .rows {
        margin-bottom: 30px;
        .el-select {
          width: 680px !important;
          border: 1px solid #003478 !important;
          .el-input--suffix .el-input__inner {
            border: 0px !important;
          }
        }
        .el-date-editor--date {
          width: 680px !important;
          border: 1px solid #003478 !important;
          .el-input__inner {
            border: 0px !important;
          }
        }
        .phone-error {
          color: #ed3e3e;
          line-height: 30px;
          height: 30px;
        }

        p.label {
          position: relative;
          padding-left: 10px;
          height: 20px;
          line-height: 20px;
          font-size: 16px;
          color: #333;
          margin-bottom: 10px;
        }
        p.label.check::before {
          position: absolute;
          content: "";
          top: 5px;
          left: 0;
          width: 5px;
          height: 5px;
          background: #ae954f;
          border-radius: 50%;
        }
        .editInp {
          width: 100%;
          height: 40px;
          padding: 10px;
          font-size: 14px;
          color: #333;
          border: 1px solid $color-primary;
          box-sizing: border-box;
        }
        .datetime {
          padding: 0;
          .vdatetime-input {
            width: 600px;
            height: 38px;
          }
        }
        .radio-box {
          overflow: hidden;
          margin: 20px 10px;
          li.radio-item {
            float: left;
            margin-right: 50px;
            i {
              position: relative;
              float: left;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              margin-right: 10px;
              border: 1px solid $color-primary;
              cursor: pointer;
            }
            span {
              float: left;
              line-height: 20px;
            }
          }
          li.radio-item.active {
            i::before {
              content: "";
              position: absolute;
              left: 6px;
              top: 6px;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: $color-primary;
            }
          }
        }
        .channel.radio-box {
          li.radio-item {
            width: 220px;
            margin-bottom: 15px;
          }
        }
        .textarea {
          width: 100%;
          border: 1px solid $color-primary;
          font-size: 14px;
          color: #333;
          line-height: 25px;
          padding: 10px;
          box-sizing: border-box;
        }
      }
      .date.rows {
        position: relative;
        .el-date-editor--date .el-input__prefix .el-icon-date {
          color: #003478 !important;
        }
        .editInp {
          padding-left: 40px;
        }
        i.icon {
          position: absolute;
          top: 40px;
          left: 10px;
          display: block;
          width: 20px;
          height: 20px;
          background: url("../../assets/image/signup_icon_date.png") no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
      .submit-btn {
        width: 300px;
        height: 50px;
        line-height: 50px;
        font-size: 22px;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        border-radius: 2px;
        margin: 0 auto;
        font-family: PingFangSC-Regular;
        background: rgba(174, 149, 79, 1);
        cursor: pointer;
      }
    }
    .garden-information {
      width: 680px;
      height: 186px;
      border: 1px solid #ae954f;
      padding: 28px 60px;
      box-sizing: border-box;
      margin: 50px auto 100px;
      font-family: PingFangSC-Regular;
      .left {
        width: 310px;
        float: left;
        .info {
          width: 100%;
          padding-left: 25px;
          position: relative;
          height: 20px;
          line-height: 20px;
          margin-bottom: 10px;
          box-sizing: border-box;
          i.icon {
            width: 20px;
            height: 20px;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            background: url("../../assets/image/icon.png") no-repeat;
          }
          i.icon.icon1 {
            background-position: -20px -140px;
          }
          i.icon.icon2 {
            background-position: -73px -140px;
          }
          i.icon.icon3 {
            background-position: -50px -140px;
          }
        }
        .info:last-child {
          margin-top: 30px;
        }
      }
      .right {
        width: 128px;
        height: 128px;
        float: right;
        img {
          width: 100%;
          border: 1px solid #ae954f;
        }
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
		.fade-leave-to/* .fade-leave-active below version 2.1.8 */
		 {
    opacity: 0;
  }
}
// @media (min-width: 401px) and (max-width: 600px) {
//   .el-popper,
//   .el-select-dropdown {
//     left: 62% !important;
//   }
// }
// @media (min-width: 375px) and (max-width: 400px) {
//   .el-popper,
//   .el-select-dropdown {
//     left: 68% !important;
//   }
// }
// @media (min-width: 320px) and (max-width: 374px) {
//   .el-popper,
//   .el-select-dropdown {
//     left: 72% !important;
//   }
// }
@media (max-width: 768px) {
  .parents-reservation {
    width: 100%;
    .content {
      overflow: hidden;
      .select-garden {
        margin-top: 30px;
        margin-bottom: 30px;
        .name {
          font-size: 21px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          height: 25px;
          line-height: 25px;
          padding-right: 0;
        }
      }
      .from-box {
        width: 82%;
        margin: 0 auto;
        box-sizing: border-box;
        font-family: PingFangSC-Regular;
        .rows {
          margin-bottom: 25px;
          .el-select {
            width: 100% !important;
            height: 35px;
          }
          .el-input,
          .el-input__inner {
            height: 35px;
          }
          .el-date-editor--date {
            width: 100% !important;
            .el-input__icon {
              line-height: 37px;
            }
          }
          .el-popper,
          .el-select-dropdown {
            left: 62% !important;
          }
          .phone-error {
            color: #ed3e3e;
            line-height: 30px;
            height: 30px;
          }

          p.label {
            position: relative;
            padding-left: 10px;
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            color: #333;
            font-family: PingFangSC-Regular;
            margin-bottom: 10px;
          }
          p.label.check::before {
            position: absolute;
            content: "";
            top: 5px;
            left: 0;
            width: 5px;
            height: 5px;
            background: #ae954f;
            border-radius: 50%;
          }
          .editInp {
            width: 100%;
            height: 35px;
            line-height: 35px;
            padding: 0 10px;
            font-size: 14px;
            color: #333;
            border: 1px solid $color-primary;
            box-sizing: border-box;
            outline: none;
          }
          .radio-box {
            li.radio-item {
              line-height: 17px;
              i {
                position: relative;
                float: left;
                width: 15px;
                height: 15px;
                margin-right: 5px;
              }
              span {
                line-height: 17px;
              }
            }
            li.radio-item.active {
              i::before {
                content: "";
                position: absolute;
                left: 4px;
                top: 4px;
                width: 7px;
                height: 7px;
                border-radius: 50%;
                background: $color-primary;
              }
            }
          }
          .channel.radio-box {
            li.radio-item {
              width: 220px;
              margin-bottom: 15px;
            }
          }
          .textarea {
            outline: none;
            height: 98px;
          }
        }
        .note-row {
          p.label {
            padding-left: 0;
          }
        }
        .channel-row {
          p.label {
            padding-left: 0;
            height: 40px;
          }
          .radio-box li.radio-item {
            i {
              margin-right: 10px;
            }
            span {
              font-size: 13px;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
            }
          }
          .channel {
            margin-bottom: 10px;
          }
        }
        .submit-btn {
          width: 37%;
          height: 28px;
          line-height: 28px;
          font-size: 22px;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          border-radius: 2px;
          margin: 0 auto;
          font-family: PingFangSC-Regular;
          background: rgba(174, 149, 79, 1);
          font-size: 12px;
          padding: 0 5px;
        }
      }
      .garden-information {
        width: 82%;
        height: 80px;
        border: 1px solid #ae954f;
        padding: 15px 5.8%;
        box-sizing: border-box;
        margin: 50px auto 46;
        font-family: PingFangSC-Regular;
        .left {
          width: 100%;
          .info {
            width: 100%;
            padding-left: 25px;
            position: relative;
            height: 20px;
            line-height: 20px;
            margin-bottom: 10px;
            box-sizing: border-box;
            font-size: 10px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            i.icon {
              width: 20px;
              height: 20px;
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              background: url("../../assets/image/icon.png") no-repeat;
            }
            i.icon.icon1 {
              background-position: -20px -140px;
            }
            i.icon.icon2 {
              background-position: -73px -140px;
            }
            i.icon.icon3 {
              background-position: -50px -140px;
            }
          }
          .info:nth-child(2) {
            margin-bottom: 0;
          }
        }
        .right {
          display: none;
        }
      }
    }
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter,
		.fade-leave-to/* .fade-leave-active below version 2.1.8 */
		 {
      opacity: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/appointment/parents.vue